import type { Questionnaire } from '@medplum/fhirtypes'
import {
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

export const steadiQuesionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/STEADI',
  title: 'Stay Independent panel [Stay Independent]',
  name: 'STEADI',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  code: [
    {
      system: 'http://loinc.org',
      code: '97874-2',
      display: 'Stay Independent panel [Stay Independent]',
    },
  ],
  item: [
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://www.cdc.gov/steadi/pdf/steadi-brochure-stayindependent-508.pdf',
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '52552-7',
          display: 'I have fallen in the past year',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/52552-7',
      text: 'I have fallen in the past year',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97875-9',
          display:
            'I use or have been advised to use a cane or walker to get around safely',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97875-9',
      text: 'I use or have been advised to use a cane or walker to get around safely',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97876-7',
          display: 'Sometimes I feel unsteady when I am walking',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97876-7',
      text: 'Sometimes I feel unsteady when I am walking',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97877-5',
          display:
            'I steady myself by holding onto furniture when walking at home',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97877-5',
      text: 'I steady myself by holding onto furniture when walking at home',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97878-3',
          display: 'I am worried about falling',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97878-3',
      text: 'I am worried about falling',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97879-1',
          display: 'I need to push with my hands to stand up from a chair',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97879-1',
      text: 'I need to push with my hands to stand up from a chair',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97880-9',
          display: 'I have some trouble stepping up onto a curb',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97880-9',
      text: 'I have some trouble stepping up onto a curb',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97881-7',
          display: 'I often have to rush to the toilet',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97881-7',
      text: 'I often have to rush to the toilet',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97882-5',
          display: 'I have lost some feeling in my feet',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97882-5',
      text: 'I have lost some feeling in my feet',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97883-3',
          display:
            'I take medicine that sometimes makes me feel light-headed or more tired than usual',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97883-3',
      text: 'I take medicine that sometimes makes me feel light-headed or more tired than usual',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '97884-1',
          display: 'I take medicine to help me sleep or improve my mood',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/97884-1',
      text: 'I take medicine to help me sleep or improve my mood',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'choice',
      code: [
        {
          code: '48527-6',
          display: 'I often feel sad or depressed',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
          valueCodeableConcept: {
            coding: [
              {
                system: 'http://hl7.org/fhir/questionnaire-item-control',
                code: 'drop-down',
                display: 'Drop down',
              },
            ],
            text: 'Drop down',
          },
        },
      ],
      linkId: '/48527-6',
      text: 'I often feel sad or depressed',
      answerOption: [
        {
          valueCoding: {
            code: 'LA33-6',
            display: 'Yes',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
        },
        {
          valueCoding: {
            code: 'LA32-8',
            display: 'No',
            system: 'http://loinc.org',
          },
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
        },
      ],
    },
    {
      type: 'decimal',
      code: [
        {
          code: '97885-8',
          display: 'Total',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit',
          valueCoding: {
            code: '{score}',
            display: '{score}',
            system: 'http://unitsofmeasure.org',
          },
        },
      ],
      linkId: '/97885-8',
      text: 'Total',
    },
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire
